import { Button, FilterCommon, Table } from "@/components";
import {
  filtersJson,
  handleMessagesAPI,
  PAGINATION_DEFAULT,
  POLICY_CONFIG_WORK_SCHEDULE_CONFIG_SCREEN,
  ROUTER_PAGE_POLICY_CONFIG_CREATE,
  TMS_ROLE_ADMIN,
  TMS_ROLE_HR,
  TMS_ROLE_HRM,
  workScheduleConfigColumns,
} from "@/utils";
import { mapState } from "vuex";

const actions = [
  {
    key: "history",
    value: "history",
    title: "History",
  },
  {
    key: "edit",
    value: "edit",
    title: "Edit",
  },
  {
    key: "remove",
    value: "remove",
    title: "Remove",
  },
];
export default {
  name: "WorkScheduleConfig",
  components: {
    FilterCommon,
    Button,
    Table,
  },
  data() {
    return {
      columns: workScheduleConfigColumns,
      POLICY_CONFIG_WORK_SCHEDULE_CONFIG_SCREEN,
      filter: PAGINATION_DEFAULT,
      dataFilterDefault: {},
      actions,
      filterList: filtersJson[POLICY_CONFIG_WORK_SCHEDULE_CONFIG_SCREEN],
    };
  },
  watch: {
    filter() {
      this.getPolicyConfigList();
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      policyConfigList: (state) => state.policyConfig.policyConfigList,
      pages: (state) => state.policyConfig.pages,
    }),
    checkShowAction() {
      const {
        userInfo: { roles },
      } = this;
      return roles?.some((role) => [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN].includes(role));
    },
  },
  mounted() {
    this.getPolicyConfigList();
  },
  methods: {
    async getPolicyConfigList() {
      this.$store.dispatch("user/loadingRequest");
      try {
        await this.$store.dispatch("policyConfig/getPolicyConfigList", this.filter);
      } catch (error) {
        handleMessagesAPI(error.response.data);
      } finally {
        this.$store.commit("user/RESET_LOADING");
      }
    },
    handleFilter(payload) {
      this.filter = { ...this.filter, ...payload, page: 1 };
    },
    handleAddNew() {
      this.$router.push({ name: ROUTER_PAGE_POLICY_CONFIG_CREATE });
    },
    onAction() {},
    handleChangePagination(payload) {
      this.filter = { ...this.filter, ...payload };
    },
  },
};
